export function inheritorLevelZangName(id) {
    if(id == 1) {
        return 'རྒྱལ་ཁབ་རིམ་པའི་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།'
    } else if(id == 2) {
        return 'མཚོ་སྔོན་ཞིང་ཆེན་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།'
    } else if(id == 3) {
        return 'མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།'
    } else if(id == 4) {
        return 'མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་ཐུན་རིན་གྲོང་ཁྱེར་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།'
    }
}
export function artistsLevelZangName(id) {
    if(id == 1) {
        return 'ཀྲུང་གོའི་མཛེས་རྩལ་བཟོ་རྩལ་མཁས་པ།'
    } else if(id == 2) {
        return 'མཚོ་སྔོན་ཞིང་ཆེན་གྱི་མཛེས་རྩལ་བཟོ་རྩལ་མཁས་པ།'
    } else if(id == 3) {
        return 'མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།'
    } else if(id == 4) {
        return 'མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་ཁྱེར་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།'
    }
}
export function technologistLevelZangName(id) {
    if(id == 1) {
        return 'མཚོ་སྔོན་ཞིང་ཆེན་དམངས་ཁྲོད་བཟོ་རྩལ་མཁས་པ།'
    } else if(id == 2) {
        return 'མཚོ་སྔོན་ཞིང་ཆེན་གྱི་རིམ་པ་དང་པོའི་དམངས་ཁྲོད་ཀྱི་བཟོ་རྩལ་མཁས་པ།'
    } else if(id == 3) {
        return 'མཚོ་སྔོན་ཞིང་ཆེན་གྱི་རིམ་པ་གཉིས་པའི་དམངས་ཁྲོད་ཀྱི་བཟོ་རྩལ་མཁས་པ།'
    } else if(id == 4) {
        return 'མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་གསུམ་པ་'
    } else if(id == 5) {
        return 'རྨ་ལྷོ་ཁུལ་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་མཁས་པ།'
    } else if(id == 6) {
        return 'ཐུན་རིན་རྫོང་དམངས་ཁྲོད་བཟོ་རྩལ་མཁས་པ།'
    }
}